module.exports = __webpack_public_path__ + "static/media/img2-5.5877b9ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/papa/biosense/diff/img2-5.png
// module id = 1983
// module chunks = 3